import {
  GET_COURSE_INDEX_PAR_LOADING,
  GET_COURSE_INDEX_PAR_SUCCESS,
  GET_COURSE_INDEX_PAR_ERROR,
  CLEAR_COURSE_INDEX_PAR,
} from "../../../constant/actionTypes";

const getScoreCardParAndIndex = (state = {}, action) => {
  switch (action.type) {
    case GET_COURSE_INDEX_PAR_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_COURSE_INDEX_PAR_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_COURSE_INDEX_PAR_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_COURSE_INDEX_PAR:
      return {};
    default:
      return state;
  }
};

export default getScoreCardParAndIndex;
